/* eslint-disable @typescript-eslint/naming-convention */

/** One run window of a component option, as the API ships it in `schedule`. */
export type ComponentOptionScheduleResponseType = {
  start_date_time: string
  end_date_time: string
}

/** One run window of a component option, as the UI keeps it. */
export type ComponentOptionScheduleType = {
  startDateTime: string
  endDateTime: string
}

/**
 * Fields an option row may carry its run window in: older rows ship one window
 * flat, newer ones (catalogue) ship every window under `schedule`.
 */
export type ComponentOptionScheduleFieldsType = {
  start_date_time?: string
  end_date_time?: string
  schedule?: ComponentOptionScheduleResponseType[] | null
}

const isSameSchedule = (a: ComponentOptionScheduleType, b: ComponentOptionScheduleType) =>
  a.startDateTime === b.startDateTime && a.endDateTime === b.endDateTime

/** Reads both shapes into one list of windows. */
export const toSchedules = ({
  start_date_time,
  end_date_time,
  schedule,
}: ComponentOptionScheduleFieldsType): ComponentOptionScheduleType[] => [
  ...(start_date_time || end_date_time
    ? [{ startDateTime: start_date_time || '', endDateTime: end_date_time || '' }]
    : []),
  ...(schedule || []).map((item) => ({
    startDateTime: item.start_date_time || '',
    endDateTime: item.end_date_time || '',
  })),
]

/** Adds the windows not already listed; rows repeat per hub with the same schedule. */
export const mergeSchedules = (
  current: ComponentOptionScheduleType[],
  next: ComponentOptionScheduleType[],
) =>
  next.forEach((item) => {
    if (!current.some((existing) => isSameSchedule(existing, item))) {
      current.push(item)
    }
  })
